<template lang="pug">
  footer
    .main-width
      ul.links
        li
          a(href="https://raid-gaming.net/privacy/", title="Privacy Policy") Privacy Policy
        li
          a(href="https://raid-gaming.net/contact/", title="Contact Us") Contact Us

      .copyright Copyright &copy; Raid Gaming

      .social-icons
        a(href="https://steamcommunity.com/groups/Raid-Steam-Group", title="Steam", target="_blank") #[steam-icon]
        a(href="https://discordapp.com/invite/G63ndc3", title="Discord", target="_blank") #[discord-icon]
</template>

<script>
import SteamIcon from 'vue-material-design-icons/Steam.vue';
import DiscordIcon from 'vue-material-design-icons/Discord.vue';

export default {
  name: 'AppFooter',
  components: {
    SteamIcon,
    DiscordIcon,
  },
};
</script>

<style lang="scss" scoped>
@import '@/style/definitions';

footer {
  background: $color-content-bg;
  margin: 32px 0 0;
  border-top: 2px solid $color-accent;
  font-size: 13px;

  @media screen and (max-width: 979px) {

  }

  .main-width {
    padding: 32px 16px;
    overflow: hidden;
    position: relative;

    @media screen and (max-width: 979px) {
      padding: 48px 0 64px;
    }
  }

  .copyright {
    float: left;
    color: $color-footer-fg;
    opacity: .8;

    @media screen and (max-width: 979px) {
      float: none;
      text-align: center;
    }
  }

  ul.links {
    list-style: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: row;
    opacity: .8;

    li a {
      padding: 0 8px;
      text-decoration: none;
      color: $color-footer-fg;

      &:hover, &:focus {
        color: $color-accent;
      }
    }

    @media screen and (max-width: 979px) {
      position: relative;
      display: inline-block;
      text-align: center;

      li {
        float: left;
      }
    }
  }

  .social-icons {
    float: right;
    opacity: .8;
    display: flex;

    a {
      position: relative;
      width: 36px;

      svg {
        position: absolute;
        top: -6px;
        width: 24px;
        height: 24px;
        fill: $color-footer-fg;

        @media screen and (max-width: 979px) {
          position: relative;
          top: 0;
        }
      }

      &:hover svg, &:focus svg {
        fill: $color-accent;
      }
    }

    @media screen and (max-width: 979px) {
      float: none;
      position: absolute;
      bottom: 24px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
}
</style>
